import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WebviewMessageBus {
  private _channel: WebviewChannel = (window as any).JSInterface ?? {};

  closeWebView() {
    if (this._channel.closeWebView) {
      this._channel.closeWebView();
    }
  }

  federateTo(auth: string, client: string, fedUrl: string) {
    if (this._channel.callToActionWithParams) {
      this._channel.callToActionWithParams(auth, client, fedUrl);
    }
  }

  accredoFederation(ext: string, provider: string) {
    if (this._channel.callToAction) {
      this._channel.callToAction(ext, provider);
    }
  }

  updateCartCount(cartCount: string) {
    if (this._channel.setRxCartTotal) {
      this._channel.setRxCartTotal(cartCount);
    }
  }

  getMobileSession() {
    return this._channel.getUniqueUserSession?.();
  }

  getTokens() {
    this._channel.retrieveAccessToken?.();
  }

  hasRetrieveAccessTokenMethod() {
    return !!this._channel.retrieveAccessToken;
  }
}

export interface WebviewChannel {
  closeWebView?(): void;
  callToActionWithParams?(auth: string, provider: string, fedUrl: string): void;
  callToAction?(ext: string, provider: string): void;
  setRxCartTotal?(cartCount: string): void;
  getUniqueUserSession?(): string;
  retrieveAccessToken?(): void;
}
